import { RouteRecordRaw } from 'vue-router';

export const routes: Array<RouteRecordRaw> = [
  {
    path: 'chat-bot-intent',
    name: 'ChatBotIntent',
    component: () => import('~/views/chatBot/lists/ChatBotIntent.vue'),
    meta: {
      title: 'Чат-бот Темы',
    }
  },
  {
    path: 'chat-bot-intent/detail/:id?',
    name: 'ChatBotIntentDetails',
    component: () => import('~/views/chatBot/list-items/ChatBotIntentDetails.vue'),
    meta: {
      title: 'Чат-бот Тема',
    }
  },
];